import { modifier } from 'ember-modifier';

export default modifier(function onDestroy(_element: Element, positional: [() => void]) {
  const [callback] = positional;

  return () => {
    callback();
  };
});
